/**
 * @module flight.service
 */
import { DialVerseApi } from '../app/api'
import AppConfig from '../config'

const FlightService = DialVerseApi.injectEndpoints({
  endpoints: (builder) => ({
    getFlights: builder.mutation({
      query: (credentials) => ({
        url: AppConfig.getUrl('/flights'),
        method: 'GET',
      }),
    }),
    getFlight: builder.mutation({
      query: (flightId) => ({
        url: AppConfig.getUrl(`/flights/${flightId}`),
        method: 'GET',
      }),
    }),
    getFlightByFlightNumber: builder.mutation({
      query: (flightNumber) => ({
        url: AppConfig.getUrl(`/flights/number/${flightNumber}`),
        method: 'GET',
      }),
    }),
    createFlight: builder.mutation({
      query: (flight) => ({
        url: AppConfig.getUrl('/flights'),
        method: 'POST',
        body: flight,
      }),
    }),
    updateFlight: builder.mutation({
      query: ({ flightId, ...updates }) => ({
        url: AppConfig.getUrl(`/flights/${flightId}`),
        method: 'PUT',
        body: updates,
      }),
    }),
    deleteFlight: builder.mutation({
      query: (flightId) => ({
        url: AppConfig.getUrl(`/flights/${flightId}`),
        method: 'DELETE',
      }),
    }),
    updateFlightStatus: builder.mutation({
      query: ({ flightId, status }) => ({
        url: AppConfig.getUrl(`/flights/${flightId}/status`),
        method: 'PATCH',
        body: { status },
      }),
    }),
    bookSeats: builder.mutation({
      query: ({ flightId, count }) => ({
        url: AppConfig.getUrl(`/flights/${flightId}/book-seats`),
        method: 'POST',
        body: { count },
      }),
    }),
    cancelSeats: builder.mutation({
      query: ({ flightId, seatIds }) => ({
        url: AppConfig.getUrl(`/flights/${flightId}/cancel-seats`),
        method: 'POST',
        body: { seatIds },
      }),
    }),
    getFlightsByAirline: builder.query({
      query: (airlineId) => ({
        url: AppConfig.getUrl(`/flights/airline/${airlineId}`),
        method: 'GET',
      }),
    }),
  }),
  overrideExisting: false,
})

export const {
  useGetFlightsMutation,
  useGetFlightMutation,
  useGetFlightByFlightNumberMutation,
  useCreateFlightMutation,
  useUpdateFlightMutation,
  useDeleteFlightMutation,
  useUpdateFlightStatusMutation,
  useBookSeatsMutation,
  useCancelSeatsMutation,
  useGetFlightsByAirlineQuery,
} = FlightService
